<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 15.417130000000002 10.3125"
    width="15.417130000000002"
    height="10.3125"
  >
    <g transform="translate(0, 0)">
      <g transform="translate(1.1102230246251565e-15, 0) rotate(0)">
        <path
          d="M15.41713,9.375c0,0.5175 -0.43168,0.9375 -0.96357,0.9375h-13.48999c-0.53189,0 -0.96357,-0.42 -0.96357,-0.9375v-8.4375c0,-0.5175 0.43168,-0.9375 0.96357,-0.9375h13.48999c0.53189,0 0.96357,0.42 0.96357,0.9375zM8.4192,7.33687c-0.37627,0.36609 -0.98573,0.36609 -1.36249,0l-0.76122,-0.74062l-2.93022,2.77875h8.72128l-2.92925,-2.75578zM13.58924,0.9375h-11.71461l5.83394,5.625zM0.96357,1.40906v7.96594h0.99296l3.62688,-3.47109zM13.51938,9.375h0.93418v-7.90875l-4.56154,4.43766z"
          :fill="color"
          style="
            stroke: rgb(140, 140, 140);
            stroke-width: 0px;
            stroke-linecap: butt;
            stroke-linejoin: miter;
          "
          vector-effect="non-scaling-stroke"
        />
      </g>
      <defs>
        <path
          id="path-1622162761527512"
          d="M15.41713,9.375c0,0.5175 -0.43168,0.9375 -0.96357,0.9375h-13.48999c-0.53189,0 -0.96357,-0.42 -0.96357,-0.9375v-8.4375c0,-0.5175 0.43168,-0.9375 0.96357,-0.9375h13.48999c0.53189,0 0.96357,0.42 0.96357,0.9375zM8.4192,7.33687c-0.37627,0.36609 -0.98573,0.36609 -1.36249,0l-0.76122,-0.74062l-2.93022,2.77875h8.72128l-2.92925,-2.75578zM13.58924,0.9375h-11.71461l5.83394,5.625zM0.96357,1.40906v7.96594h0.99296l3.62688,-3.47109zM13.51938,9.375h0.93418v-7.90875l-4.56154,4.43766z"
          vector-effect="non-scaling-stroke"
        />
      </defs>
    </g>
  </svg>
</template>
<script>
export default {
  name: "EnvelopeSimple",
  props: {
    color: {
      type: String,
      default() {
        return '#FFFFFF';
      },
    },
  }
};
</script>